import { gql } from "@apollo/client";

const REMOVE_PLATFORM = gql`
  mutation removeOrganizationPlatform($id: Int!) {
    removeOrganizationPlatform(id: $id)
  }
`;

export default REMOVE_PLATFORM;
